import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import CommonLabelAnswer, {
  LabelAnswerProps as CommonLabelAnswerProps,
} from 'themes/common/components/answers/LabelAnswer'
import ExtraPriceLabel from 'themes/common/components/ExtraPriceLabel'
import DescriptionTooltip from 'themes/common/components/answers/DescriptionTooltip'

import './LabelAnswer.scss'

export type LabelAnswerProps = CommonLabelAnswerProps & {
  price?: string | number
  currency: string
  lang?: string
  country?: string
  isOutOfStock?: boolean
  showRelativePrice?: boolean
}

const LabelAnswer = (props: LabelAnswerProps) => {
  const answerStyle = useThemeSettings('answer')
  const { fieldBorderRadius: borderRadius } = useThemeSettings('textInputAndDropdown')

  const answerStyleWithBorderRadius = {
    ...answerStyle,
    borderRadius,
  }

  return (
    <>
      <DescriptionTooltip
        allowHeaderOnly={false}
        key={`tooltip-${props.id}`}
        description={props.description}
        showDescription={props.showDescription}
        style={answerStyle}
      >
        <CommonLabelAnswer {...props} answerStyle={answerStyleWithBorderRadius} />
      </DescriptionTooltip>
      <ExtraPriceLabel
        extraClassNames="price-label__under-label"
        price={props.price}
        currency={props.currency}
        lang={props.lang}
        country={props.country}
        showRelativePrice={props.showRelativePrice}
      />
    </>
  )
}

export default LabelAnswer
